import apiBase from "./api-base";

export default class Asset extends apiBase {
    constructor(store) {
        const path = "v1/Asset";
        super(store, path);
    }
    Create(model){
        return this._request({
          action: "Create",
          method: "POST",
          body: model,
        });
      }
    
      Get(filter) {
        return this._request({
          action: "Get",
          method: "GET",
          params: filter,
        });
      }
      CreateAssetLink(model) {
        return this._request({
          action: "CreateAssetLink",
          method: "POST",
          body: model,
        });
      }
      GetAssetLinks(filter) {
        return this._request({
          action: "GetAssetLinks",
          method: "GET",
          params: filter,
        });
      }
      Update(model,ikey) {
        return this._request({
          action: `Update/${ikey}`,
          method: "PUT",
          body: model,
        });
      }ß
      Delete(ikey) {
        return this._request({
          action: `Delete/${ikey}`,
          method: "DELETE",
          
        });
      }
      DeleteLink(model) {
        return this._request({
          action: "DeleteAssetLink",
          method: "DELETE",
          body:model
          
        });
      }
}